
// Custom regel för Vee-validate: 'remote:{validateSubUrlSegment}'. Validerar medelst request till backend med axios:

import axios from 'axios';
import objectToFormData from 'object-to-formdata';
import { Resultat } from 'classes/ResultatClasses';
import { Validator } from 'vee-validate';



// https://baianat.github.io/vee-validate/guide/custom-rules.html#using-the-custom-rule:

const ruleValidator = {

	getMessage(field, [validateSubUrlSegment], data)
	{
		// will be added to default locale messages.
		// Returns a message.
		// data från validatorn:

		if (data
			&& Array.isArray(data)
			&& data.length !== 0)
		{
			// Obs! Vi jobbar inte med fältnamn, så i det här läget är field === '{field}'. Därför funkar inte detta så bra:
			// Men, i detta sammanhang kan väl data bara innehålla data från den egna specifika validate() nedan, så filtreringen kan vi hoppa över... *Ätror* jag. Testar:
			//const msg = data.filter((item) => { return item.Field === field; })[0].MessageHtml;
			const msg = data[0].MessageTextOrHtml;		// Bara det första, om flera finns.

			if (msg)
				return msg;
		}

		return 'Något är fel, men det finns ingen information om vad  :(';	// Todo: Kanske bättre med null/undefined sen?
	},

	validate(value, [validateSubUrlSegment])
	{
		// Returns a Boolean or a Promise that resolves to a boolean.
		// value = fältets aktuella innehåll.

		return axios.post('/validate/' + validateSubUrlSegment, objectToFormData({ value: value }))
			.then((response) =>
			{
				// respone.data är på formatet
				const psr = Resultat
					.castFrom(response.data);

				// Notice that we return an object containing both a valid property and a data property.
				return {
					valid: (psr.Succeeded || (psr.Messages[0].Code.startsWith('inte-inloggad'))),		// Är man utloggad så betraktas valideringen som godkänd!
					data: psr.Messages
					//{
					//	message: response.data.messageHtml
					//}
				};
			});
	}
};


let redanKord = false;


export default {

	runOnce()
	{
		if (!redanKord)
		{
			redanKord = true;
			Validator.extend('remote', ruleValidator);
		}
	}
}

